import request from '../../../services/request';
export var getProductDetails = function getProductDetails(mcpSku) {
  return request("https://introduction.products.cimpress.io/v3/mcpSkus/" + mcpSku);
};